type Locale = 'en' | 'hi';

const STORAGE_KEY = 'ci_locale';

const messages: Record<Locale, Record<string, string>> = {
  en: {
    'dashboard.title': 'Dashboard',
    'dashboard.emissions': 'Emissions overview',
    'reporting.title': 'Disclosure reports',
    'reporting.draftNotice': 'Draft — not for statutory filing',
    'reporting.filingReady': 'Filing ready',
    'reporting.exportCsv': 'Export carbon footprint CSV',
    'common.loading': 'Loading…',
    'common.retry': 'Retry',
    'common.shareWhatsApp': 'Share on WhatsApp',
    'common.confirmDraft': 'Confirm draft values',
    'common.language': 'Language',
    'reporting.tab.overview': 'Overview',
    'reporting.tab.brsr': 'BRSR',
    'reporting.tab.brsr.hint': 'Indian buyers',
    'reporting.tab.iso14064': 'ISO 14064',
    'reporting.tab.iso14064.hint': 'Banks & lenders',
    'reporting.tab.iso14067': 'ISO 14067',
    'reporting.tab.iso14067.hint': 'Product buyers',
    'reporting.tab.cbam': 'CBAM',
    'reporting.tab.cbam.hint': 'EU export',
    'reporting.tab.overview.hint': 'Pick a goal',
    'reporting.period': 'Reporting period',
    'reporting.refresh': 'Refresh',
    'reporting.export': 'Export',
    'reporting.email': 'Email',
    'reporting.print': 'Print',
    'reporting.period.1month': 'Last month',
    'reporting.period.3months': 'Last 3 months',
    'reporting.period.6months': 'Last 6 months',
    'reporting.period.1year': 'Last year',
    'reporting.shareDelivery': 'Share & delivery',
    'reporting.reviewAutopilot': 'Review autopilot suggestions',
    'reporting.reviewAutopilotDetail': 'These values were suggested from your profile and bills. Confirm each item or confirm all to include in your readiness score.',
    'reporting.draftConfirmed': 'Confirmed {count} draft value(s) — readiness score will update on next check.',
    'reporting.draftNoneNeeded': 'No draft values needed confirmation.',
    'reporting.draftConfirmFailed': 'Confirmation failed.',
    'reporting.scheduledReports': 'Scheduled delivery',
    'reporting.supplierScores': 'Supplier carbon scores',
    'common.confirmOne': 'Confirm',
    'common.confirmAllDraft': 'Confirm all suggestions',
    'common.dismissOne': 'Dismiss',
    'common.dismissAllDraft': 'Dismiss all suggestions',
    'reporting.draftRejected': 'Dismissed {count} draft suggestion(s) — they will not count toward readiness.',
    'reporting.draftRejectFailed': 'Dismiss failed.',
    'copilot.title': 'AI Advisor',
    'copilot.subtitle': 'Ask about your organisation’s sustainability — footprint, water, hotspots, solar, action plans, and cheapest ways to cut emissions.',
    'copilot.questionLabel': 'Your question',
    'copilot.questionPlaceholder': 'Ask about your footprint, water, solar, or how to cut emissions',
    'copilot.ask': 'Ask',
    'copilot.noAnswer': 'No answer returned.',
    'copilot.questionFailed': 'Question failed',
    'copilot.welcome': 'I am your AI Advisor for Sustainow. Ask about water savings, footprint changes, hotspots, solar ROI, FY action plans, or the cheapest path to cut emissions. I use your organisation’s assessments, bills, and recommendations.',
    'copilot.emptyHint': 'Choose a suggested question, or type your own.',
    'copilot.thinking': 'Thinking…',
    'copilot.openSuggested': 'Open suggested page',
    'carbon.totalFootprint': 'Total Carbon Footprint',
    'carbon.assessmentOverview': 'Assessment overview',
    'carbon.perMonth': 'per month (wizard assessment total)',
    'carbon.analyticsOverview': 'Carbon analytics overview',
    'carbon.analyticsDashboard': 'Carbon analytics dashboard',
    'carbon.recommendations': 'Carbon reduction recommendations',
    'carbon.reportsLink': 'Reports',
    'carbon.section1': 'Section 1',
    'carbon.section2': 'Section 2',
    'carbon.carbonScore': 'Carbon Score',
    'carbon.scoreExcellent': 'Excellent',
    'carbon.scoreGood': 'Good',
    'carbon.scoreNeedsImprovement': 'Needs Improvement',
    'carbon.companyEmissionsSnapshot': 'Company emissions snapshot',
    'carbon.companyEmissionsSnapshotBody': 'Compare the footprint from this assessment with operational transactions and document-derived totals from Upload documents. Use this triangulation for management review and disclosure prep.',
    'carbon.emissionsBySource': 'Emissions by source',
    'carbon.emissionsBySourceBody': 'Side-by-side views of the assessment model, classified transactions, and workflow-derived monthly drivers—fuel, transport, electricity, water, chemicals, and materials. Scope totals stay in the scope cards on this page.',
    'carbon.operationalAnalyticsContext': 'Operational analytics context',
    'carbon.recommendationsBody': 'Prioritized decarbonization actions synthesized from your assessments, transactions, and analytics engine.',
    'carbon.analyticsOverviewBody': 'Assessment totals, emissions drivers, and triangulation across transactions and uploaded documents.',
    'carbon.analyticsDashboardBody': 'Disclosure-aligned reporting charts, transaction intensity trends, and visual deep-dive analytics.',
    'compliance.indiaHub': 'India compliance hub',
    'compliance.exportHub': 'Export compliance hub',
    'dashboard.performance': 'Performance',
    'dashboard.performanceSubtitle': 'Your carbon score, total footprint, and where emissions come from.',
    'dashboard.todoActions': 'To-do actions',
    'dashboard.todoActionsSubtitle': 'Next steps: finish missing data, move your reports forward, and cut emissions.',
    'dashboard.setupFocusTitle': 'More on your dashboard',
    'dashboard.setupFocusSubtitle': 'Compliance readiness, advisory insights, and platform details — open when you are ready.',
    'dashboard.viewCarbonSavings': 'View carbon savings details',
    'dashboard.operationsPromptTitle': 'Level up your energy and meters',
    'dashboard.frameworkGapsTitle': 'Disclosure readiness',
  },
  hi: {
    'dashboard.title': 'डैशबोर्ड',
    'dashboard.emissions': 'उत्सर्जन अवलोकन',
    'reporting.title': 'प्रकटीकरण रिपोर्ट',
    'reporting.draftNotice': 'प्रारूप — वैधानिक दाखिल के लिए नहीं',
    'reporting.filingReady': 'दाखिल करने के लिए तैयार',
    'reporting.exportCsv': 'कार्बन फुटप्रिंट CSV निर्यात',
    'common.loading': 'लोड हो रहा है…',
    'common.retry': 'पुनः प्रयास',
    'common.shareWhatsApp': 'WhatsApp पर साझा करें',
    'common.confirmDraft': 'प्रारूप मानों की पुष्टि करें',
    'common.language': 'भाषा',
    'reporting.shareDelivery': 'साझा करें और डिलीवरी',
    'reporting.tab.overview': 'अवलोकन',
    'reporting.tab.overview.hint': 'लक्ष्य चुनें',
    'reporting.tab.brsr': 'BRSR',
    'reporting.tab.brsr.hint': 'भारतीय खरीदार',
    'reporting.tab.iso14064': 'ISO 14064',
    'reporting.tab.iso14064.hint': 'बैंक और ऋणदाता',
    'reporting.tab.iso14067': 'ISO 14067',
    'reporting.tab.iso14067.hint': 'उत्पाद खरीदार',
    'reporting.tab.cbam': 'CBAM',
    'reporting.tab.cbam.hint': 'EU निर्यात',
    'reporting.period': 'रिपोर्टिंग अवधि',
    'reporting.refresh': 'रीफ़्रेश',
    'reporting.export': 'निर्यात',
    'reporting.email': 'ईमेल',
    'reporting.print': 'प्रिंट',
    'reporting.period.1month': 'पिछला महीना',
    'reporting.period.3months': 'पिछले 3 महीने',
    'reporting.period.6months': 'पिछले 6 महीने',
    'reporting.period.1year': 'पिछला वर्ष',
    'reporting.reviewAutopilot': 'ऑटोपायलट सुझावों की समीक्षा करें',
    'reporting.reviewAutopilotDetail': 'ये मान आपकी प्रोफ़ाइल और बिलों से सुझाए गए थे। तैयारी स्कोर में शामिल करने के लिए प्रत्येक की पुष्टि करें या सभी की पुष्टि करें।',
    'reporting.draftConfirmed': '{count} प्रारूप मानों की पुष्टि की गई — अगली जाँच पर तैयारी स्कोर अपडेट होगा।',
    'reporting.draftNoneNeeded': 'किसी प्रारूप मान की पुष्टि की आवश्यकता नहीं।',
    'reporting.draftConfirmFailed': 'पुष्टि विफल।',
    'reporting.scheduledReports': 'अनुसूचित डिलीवरी',
    'reporting.supplierScores': 'आपूर्तिकर्ता कार्बन स्कोर',
    'common.confirmOne': 'पुष्टि करें',
    'common.confirmAllDraft': 'सभी सुझावों की पुष्टि करें',
    'common.dismissOne': 'खारिज करें',
    'common.dismissAllDraft': 'सभी सुझाव खारिज करें',
    'reporting.draftRejected': '{count} प्रारूप सुझाव खारिज किए गए — वे तैयारी में शामिल नहीं होंगे।',
    'reporting.draftRejectFailed': 'खारिज करना विफल।',
    'copilot.title': 'AI Advisor',
    'copilot.subtitle': 'संगठन की स्थिरता पर प्रश्न पूछें — पदचिह्न, पानी, हॉटस्पॉट, सोलर, एक्शन प्लान और उत्सर्जन कम करने के सस्ते तरीके।',
    'copilot.questionLabel': 'आपका प्रश्न',
    'copilot.questionPlaceholder': 'पदचिह्न, पानी, सोलर या उत्सर्जन कटौती के बारे में पूछें',
    'copilot.ask': 'पूछें',
    'copilot.noAnswer': 'कोई उत्तर नहीं मिला।',
    'copilot.questionFailed': 'प्रश्न विफल',
    'copilot.welcome': 'मैं आपका Sustainow AI Advisor हूँ। पानी की बचत, पदचिह्न बदलाव, हॉटस्पॉट, सोलर ROI, FY एक्शन प्लान या सस्ते उत्सर्जन कटौती मार्ग पूछें।',
    'copilot.emptyHint': 'कोई सुझाया प्रश्न चुनें, या नीचे अपना प्रश्न लिखें।',
    'copilot.thinking': 'सोच रहा हूँ…',
    'copilot.openSuggested': 'सुझाया गया पेज खोलें',
    'carbon.totalFootprint': 'कुल कार्बन फुटप्रिंट',
    'carbon.assessmentOverview': 'मूल्यांकन अवलोकन',
    'carbon.perMonth': 'प्रति माह (विज़ार्ड मूल्यांकन कुल)',
    'carbon.analyticsOverview': 'कार्बन विश्लेषण अवलोकन',
    'carbon.analyticsDashboard': 'कार्बन विश्लेषण डैशबोर्ड',
    'carbon.recommendations': 'कार्बन कमी की सिफारिशें',
    'carbon.reportsLink': 'रिपोर्ट',
    'carbon.section1': 'अनुभाग 1',
    'carbon.section2': 'अनुभाग 2',
    'carbon.carbonScore': 'कार्बन स्कोर',
    'carbon.scoreExcellent': 'उत्कृष्ट',
    'carbon.scoreGood': 'अच्छा',
    'carbon.scoreNeedsImprovement': 'सुधार की आवश्यकता',
    'carbon.companyEmissionsSnapshot': 'कंपनी उत्सर्जन स्नैपशॉट',
    'carbon.companyEmissionsSnapshotBody': 'इस मूल्यांकन के फुटप्रिंट की तुलना परिचालन लेनदेन और अपलोड दस्तावेज़ों से प्राप्त कुल के साथ करें। प्रबंधन समीक्षा और प्रकटीकरण तैयारी के लिए इस त्रिकोणीकरण का उपयोग करें।',
    'carbon.emissionsBySource': 'स्रोत के अनुसार उत्सर्जन',
    'carbon.emissionsBySourceBody': 'मूल्यांकन मॉडल, वर्गीकृत लेनदेन और वर्कफ़्लो-व्युत्पन्न मासिक ड्राइवरों के समानांतर दृश्य। स्कोप कुल इसी पेज के स्कोप कार्ड में हैं।',
    'carbon.operationalAnalyticsContext': 'परिचालन विश्लेषण संदर्भ',
    'carbon.recommendationsBody': 'आपके मूल्यांकन, लेनदेन और विश्लेषण इंजन से संश्लेषित प्राथमिकता वाली कार्बन कमी की कार्रवाइयाँ।',
    'carbon.analyticsOverviewBody': 'मूल्यांकन कुल, उत्सर्जन ड्राइवर और लेनदेन व अपलोड दस्तावेज़ों में त्रिकोणीकरण।',
    'carbon.analyticsDashboardBody': 'प्रकटीकरण-संरेखित रिपोर्टिंग चार्ट, लेनदेन तीव्रता रुझान और दृश्य गहन-विश्लेषण।',
    'compliance.indiaHub': 'भारत अनुपालन हब',
    'compliance.exportHub': 'निर्यात अनुपालन हब',
    'dashboard.performance': 'प्रदर्शन',
    'dashboard.performanceSubtitle': 'आपका कार्बन स्कोर, कुल फुटप्रिंट और उत्सर्जन के स्रोत।',
    'dashboard.todoActions': 'करने योग्य कार्य',
    'dashboard.todoActionsSubtitle': 'अगले कदम: अधूरा डेटा पूरा करें, रिपोर्ट आगे बढ़ाएँ, और उत्सर्जन घटाएँ।',
    'dashboard.setupFocusTitle': 'आपके डैशबोर्ड पर और',
    'dashboard.setupFocusSubtitle': 'अनुपालन तैयारी, सलाहकार अंतर्दृष्टि और प्लेटफ़ॉर्म विवरण — जब तैयार हों तब खोलें।',
    'dashboard.viewCarbonSavings': 'कार्बन बचत विवरण देखें',
    'dashboard.operationsPromptTitle': 'अपनी ऊर्जा और मीटर पूरा करें',
    'dashboard.frameworkGapsTitle': 'प्रकटीकरण तैयारी',
  },
};

export const getLocale = (): Locale => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'hi' ? 'hi' : 'en';
};

export const setLocale = (locale: Locale) => {
  localStorage.setItem(STORAGE_KEY, locale);
};

export const t = (key: string, locale: Locale = getLocale()): string => (
  messages[locale][key] || messages.en[key] || key
);

export const useTranslation = () => {
  const locale = getLocale();
  return {
    locale,
    t: (key: string) => t(key, locale),
    setLocale,
  };
};

const i18n = { t, getLocale, setLocale, useTranslation };

export default i18n;
